import React from 'react';
import { FaPhoneAlt } from 'react-icons/fa';

const CallButton = ({ inline = false }) => {
  const [isAtBottom, setIsAtBottom] = React.useState(false);

  React.useEffect(() => {
    const handleScroll = () => {
      const scrollHeight = document.documentElement.scrollHeight;
      const scrollTop = window.scrollY;
      const clientHeight = window.innerHeight;
      setIsAtBottom(scrollHeight - scrollTop - clientHeight < 100);
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const baseButton = "flex items-center justify-center w-10 h-10 rounded-full shadow-lg transition-all duration-300 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2";
  const positionClass = inline ? '' : `fixed right-4 z-50 ${isAtBottom ? 'bottom-[220px]' : 'bottom-[76px]'}`;
  const buttonClasses = inline ? `${baseButton} bg-green-500 hover:bg-green-600 text-white` : `${baseButton} bg-green-500 hover:bg-green-600 text-white`;

  return (
    <a
      href="tel:+919063907346"
      className={`${buttonClasses} ${positionClass}`}
      aria-label="Call Owner"
    >
      <FaPhoneAlt className="w-6 h-6" />
    </a>
  );
};

export default CallButton;
